module.exports = __webpack_public_path__ + "static/media/Play.acf60c3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/Play.svg
// module id = 1733
// module chunks = 0